<template>
    <div class="learningCenterPage">
        <page-navigate></page-navigate>
        <div class="ebcInteractiveTopic">
            <div class="contentBox flex">
                <div class="ebcInteractiveTopicNew">
                    <div class="swiper ebcInteractiveSlide">
                        <div class="ebcInteractive-prev cursor-pointer pc">
                            <img src="@/assets/image/ebcInteractive/swiperNext.png?t=1" alt="" />
                        </div>
                        <div class="swiper-wrapper">
                            <div class="swiper-slide" v-for="(item, index) in bannerUrl" :key="index">
                                <a href="javascript:;" @click="goUrl(item.url)"><img :src="item.thumbnail" alt="" /></a>
                                <a class="ebcInteractiveTopicNewTitle subtitle-20_medium md-body-16_medium"
                                    href="javascript:;" @click="goUrl(item.url)">
                                    {{ item.post_title }}
                                </a>
                                <div class="ebcInteractiveTopicNewDesc body-14_regular md-body-14_regular">
                                    {{ item.post_excerpt }}
                                </div>
                                <div class="ebcInteractiveTopicNewTime body-14_regular md-body-14_regular">
                                    {{ ts2ymd(item.published_time) }}
                                </div>
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                        <div class="ebcInteractive-next cursor-pointer pc">
                            <img src="@/assets/image/ebcInteractive/swiperNext.png?t=1" alt="" />
                        </div>
                    </div>
                </div>
                <div class="ebcInteractiveHotList">
                    <div class="ebcInteractiveHotListTitle title-24_bold">精选推荐</div>
                    <div class="ebcInteractiveHotListItem cursor-pointer flex items-center"
                        v-for="(item, index) in recommended" :key="index">
                        <div class="itemTime">
                            <div class="itemTime-day text-center subtitle-20_medium md-body-16_medium">
                                {{ ts2Day(item.published_time) }}
                            </div>
                            <div class="itemTime-yearMonth footnote-regular_12">
                                {{ ts2Month(item.published_time) }}
                            </div>
                        </div>
                        <a class="itemWord body-16_medium md-body-14_medium" href="javascript:;"
                            @click="goUrl(item.url)">
                            {{ item.post_title }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="ebcInteractiveList">
            <div class="ebcInteractiveListTab flex subtitle-20_regular md-content-16_regular">
                <div :class="{ active: tabIndex == 0 }" @click="changeData(0, 'ebc-official')" class="cursor-pointer">
                    全部</div>
                <div :class="{ active: tabIndex == 1 }" @click="changeData(1, 'dialogue-ebc')" class="cursor-pointer">对话
                    EBC
                </div>
                <div :class="{ active: tabIndex == 2 }" @click="changeData(2, 'ebc-official-event')"
                    class="cursor-pointer">
                    福利活动</div>
                <div :class="{ active: tabIndex == 3 }" @click="changeData(3, 'win')" class="cursor-pointer">大赛新闻</div>
                <div :class="{ active: tabIndex == 4 }" @click="changeData(4, 'ebc-notice')" class="cursor-pointer">公告
                </div>
            </div>
            <div v-if="tabIndex==4" class="ebcInteractiveListSecondTab flex justify-start items-center body-14_regular md-footnote-regular_12">
                <div :class="{active:secondTabIndex== 0}" @click="changeSecondData(0)">全部</div>
                <div :class="{active:secondTabIndex== 1}" @click="changeSecondData(1)">交易时间</div>
                <div :class="{active:secondTabIndex== 2}" @click="changeSecondData(2)">交易规则</div>
                <div :class="{active:secondTabIndex== 3}" @click="changeSecondData(3)">系统通知</div>
                <div :class="{active:secondTabIndex== 4}" @click="changeSecondData(4)">其他</div>
            </div>
            <div class="ebcInteractiveListPart flex contentBox">

                <div class="ebcInteractiveListItem cursor-pointer" v-for="(item, index) in dtList" :key="index">
                    <a href="javascript:;" @click="goUrl(item.url)">
                        <img :src="item.thumbnail" alt="" />
                    </a>
                    <a class="ebcInteractiveListItemTitle body-16_medium md-body-14_medium">
                        <span class="ebcInteractiveListItemTime">{{ ts2ymd(item.published_time) }}</span>
                        {{ item.post_title }}
                    </a>
                </div>

            </div>
            <!-- <div class="ebc-page-pagination">
                <div class="page">
                    <ul class="pagination">
                        <li class="cursor-pointer page-item disabled" @click="changePageNum('-1')"
                            :class="{ disabled: pageNavigation.current_page == 1 }"><span class="page-link">«</span>
                        </li>
                        <li v-for="(p, index) in pageWindow" :key="index" class="cursor-pointer page-item"
                            :class="{ active: p === pageNavigation.current_page, disabled: p == '…' || p === pageNavigation.current_page }"
                            @click="changePageNum(p)">
                            <span class="page-link">{{ p }}</span>
                        </li>
                        <li class="page-item cursor-pointer" :class="{ disabled: pageNavigation.last_page == pageNum }"
                            @click="changePageNum('+1')"><span class="page-link">»</span></li>
                    </ul>
                </div>
            </div> -->

        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import fadeAnimate from "../mixins/fadeAnimate.js";
import 'swiper/css/swiper.css'
import Swiper from 'swiper'
import moment from 'moment';
export default {
    mixins: [fadeAnimate],
    name: '',
    data() {
        return {
            pageNum: 1,
            tabIndex: 0,
            secondTabIndex: 0,
            tabRequestTag: ['ebc-official', 'dialogue-ebc', 'ebc-official-event', 'win', 'ebc-notice'],
            secondTabRequestTag:['ebc-notice','trading-hours-update','trading-rules-update','system-announcements','other-notices'],
            bannerUrl: '',
            recommandList: '',
            dtList: [],
            pageNavigation: '',
            recommended: ''
        }
    },

    created() {
        this.tabIndex = this.$route.query.tab || 0;
        this.secondTabIndex = this.$route.query.secondTab || 0;
    },
    computed: {
        // pageWindow() {
        //     const c = this.pageNavigation.current_page;
        //     const L = this.pageNavigation.last_page;   // 24
        //     if (L <= 6) {
        //         return Array.from({ length: L }, (_, i) => i + 1);
        //     }
        //     /* 图里三种情况，L>=8 才走这里 */
        //     if (c <= 4) {                       // ① 当前页在头部
        //         return [1, 2, 3, 4, 5, '…', L - 1, L];     // 8 个元素
        //     }
        //     if (c >= L - 3) {                     // ② 当前页在尾部
        //         return [1, 2, '…', L - 4, L - 3, L - 2, L - 1, L]; // 8 个元素
        //     }
        //     /* ③ 中间段：保证当前页左右各 2 个，头 2 + 尾 2，共 8 个 */
        //     return [1, 2, '…', c - 2, c - 1, c, c + 1, c + 2, '…', L - 1, L];
        // }
        NoMoreData() {
            return this.pageNavigation.last_page == this.pageNum
        }
    },
    async mounted() {
        await this.getPageData();
        setTimeout(() => {
            this.initPage();
        }, 500)
    },


    methods: {
        goUrl(url) {
            let id = url.split('/').pop().replace('.html', '')
            location.href = `/ebcDT/${id}`
        },
        ts2ymd(ts) {
            return moment.unix(new Date(ts)).format("YYYY年MM月DD日")
        },
        ts2Day(ts) {
            return moment.unix(new Date(ts)).format("DD")

        },
        ts2Month(ts) {
            return moment.unix(new Date(ts)).format("YYYY-MM")

        },
        async getPageData() {
            console.log(this.secondTabIndex)
            const requestPath = this.secondTabIndex!=0 ? this.secondTabRequestTag[this.secondTabIndex] : this.tabRequestTag[this.tabIndex]
            await fetch(`https://academy.ebccfd.com/api/academy-list/${requestPath}?page=${this.pageNum}`).then(res => res.json()).then(res => {
                const { banner, recommended, list, pagination } = res.data
                this.dtList.push(...list)
                this.pageNum = pagination.current_page
                this.pageNavigation = pagination
                !this.bannerUrl && (this.bannerUrl = banner)
                !this.recommended && (this.recommended = recommended)
            })
        },
        changePageNum(num) {

            if (num == '…' || (num === '+1' && this.pageNum == this.pageNavigation.last_page) || (num === '-1' && this.pageNum == 1)) return
            else {
                if (num === '+1') this.pageNum++
                else if (num === '-1') this.pageNum--
                else this.pageNum = num
            }
            this.getPageData()
        },
        changeSecondData(index){
            this.pageNum = 1
            this.dtList = []
            this.secondTabIndex = index
            setTimeout(() => {
              this.setInitialScroll();
                
            })
            this.getPageData()
        },
        changeData(index) {
            this.dtList = []
            this.tabIndex = index
            this.secondTabIndex = 0
            this.pageNum = 1
            setTimeout(() => {
                this.scrollActiveIntoView()
            })
            this.getPageData()
        },
        initPage() {
            const container = document.querySelector('.ebcInteractiveListPart')
            function throttle(fn, wait) {
                let timer = null;
                return function (...args) {
                    if (timer) return;
                    timer = setTimeout(() => {
                        fn.apply(this, args);
                        timer = null;
                    }, wait);
                };
            }
            const onScroll = throttle(() => {
                const rect = container.getBoundingClientRect();
                const remain = window.innerHeight - rect.bottom; // 底部距离视口底部
                console.log(remain, 123)
                if (remain >= -10 && !this.NoMoreData) {
                    this.pageNum++;
                    this.getPageData();
                };
            }, 1000);

            document.addEventListener('scroll', onScroll);
            let mySwiper = new Swiper(".ebcInteractiveSlide", {
                loop: true,
                autoplay: true,
                spaceBetween: 24,
                navigation: {
                    nextEl: "ebcInteractive-next",
                    prevEl: "ebcInteractive-prev",
                },
                pagination: {
                    el: ".swiper-pagination",
                },
                on: {
                    slideChange: function () { },
                },
            });
            document
                .querySelector(".ebcInteractive-next")
                .addEventListener("click", function () {
                    mySwiper.slideNext();
                });
            document
                .querySelector(".ebcInteractive-prev")
                .addEventListener("click", function () {
                    mySwiper.slidePrev();
                });
            document
                .querySelectorAll(".ebcInteractiveListTab>div")
                .forEach((i, index) =>
                    i.addEventListener("click", function () {
                        document
                            .querySelector(".ebcInteractiveListTab>div.active")
                            .classList.remove("active");
                        document
                            .querySelectorAll(".ebcInteractiveListTab>div")
                        [index].classList.add("active");
                    })
                );

            // 1. 找到要观察的元素
            const el = document.querySelector('.ebcInteractiveListTab');

            // 2. 创建一个“哨兵”节点，让它紧跟在 el 后面
            const sentinel = document.createElement('div');
            sentinel.style.height = '1px';
            sentinel.style.pointerEvents = 'none';
            sentinel.style.visibility = 'hidden';
            el.parentNode.insertBefore(sentinel, el.nextSibling);

            // 3. 用 IntersectionObserver 观察哨兵
            const io = new IntersectionObserver(
                ([entry]) => {
                    // 当哨兵“离开视口顶部”时，说明 el 已经被粘住
                    el.classList.toggle('is-pinned', !entry.isIntersecting);
                },
                { threshold: [0], rootMargin: `-150px 0px 0px 0px` }
            );

            io.observe(sentinel);

            ; (() => {
                location.href.includes('tabId=6&tab=4') && document.querySelector('.ebcInteractiveListTab') &&
                    window.scrollTo({
                        top: document.querySelector('.ebcInteractiveListTab').getBoundingClientRect().top +
                            window.pageYOffset - 60,
                        behavior: 'smooth'
                    }); localStorage.removeItem('ebcNotice');


                // 页面加载完/切换 tab 后调用
                window.matchMedia('(max-width: 996px)').matches && this.scrollActiveIntoView();
            })();
              this.setInitialScroll();
        },
           setInitialScroll() {
                const box = document.querySelector('.ebcInteractiveListSecondTab');
                if (!box) return;

                const activeEl = box.querySelector('.active');
                if (!activeEl) return;
                const boxLeft = box.getBoundingClientRect().left;
                const elLeft = activeEl.getBoundingClientRect().left;
                const scrollOffset = elLeft - boxLeft;

                box.scrollLeft = scrollOffset;
            },
        scrollActiveIntoView(selector = '.ebcInteractiveListTab') {
            const list = document.querySelector(selector);
            const active = list && list.querySelector('.active');
            if (!active) return;

            const pad = 10; // 额外留边
            list.scrollTo({
                left: Math.max(0, active.offsetLeft - pad),
                behavior: 'smooth'
            });
        }
     

}
}
</script>
<style lang="scss" scoped>

.learningCenterPage {
    .swiper-pagination {
        top: 356rem;
        left: 16rem !important;
        width: fit-content !important;
        bottom: unset !important;
    }

    .swiper-pagination .swiper-pagination-bullet {
        background-color: rgba(255, 255, 255, 0.48);
        border-radius: 1998px;
        opacity: 0.5;
        width: 16rem;
        height: 2rem;
    }

    .swiper-pagination .swiper-pagination-bullet-active {
        background-color: #fff;
        opacity: 1;
        width: 32rem;
    }

    @media (max-width: 996px) {
        .learningCenterPage {
            .swiper-pagination {
                top: 420rem;
                width: 100% !important;
                bottom: unset !important;
            }

            .swiper-pagination .swiper-pagination-bullet {
                background-color: rgba(255, 255, 255, 0.48);
                border-radius: 1998px;
                opacity: 0.5;
                width: 32rem;
                height: 4rem;
                margin-right: 16rem;
            }

            .swiper-pagination .swiper-pagination-bullet-active {
                background-color: #fff;
                opacity: 1;
                width: 64rem;
            }
        }
    }
}
</style>
<style scoped>
@import url('../assets/css/forex/common.css');

.ebc-page-pagination .disabled {
    cursor: not-allowed;
}

a {
    color: var(--ebc-text-primary);
}

.learningCenterPage {
    background: url('../assets/image/ebcInteractive/ebcInteractiveHeader.png') no-repeat;
    background-color: #fff;
    background-size: 100% 980rem;
}

.contentBox {
    max-width: 1200rem;
    margin-inline: auto;
}

.ebcInteractiveTopic {
    padding: calc(80px + 64rem) 0 25rem;
}

.ebcInteractiveTopic>div {
    gap: 48rem;
}

.ebcInteractiveSlide {
    width: 588rem;
    position: relative;
    overflow: hidden;
}

.ebcInteractiveTopic .swiper-slide img {
    width: 588rem;
    height: 392rem;
    border-radius: var(--ebc-corner-radius-rc08);
    margin-bottom: 16rem;
}
.ebcInteractiveListSecondTab{
    gap: 12rem;
    max-width: 100%;
    overflow: auto;
    padding-left: calc(50vw - 600rem);
    margin-top: -18rem;
    margin-bottom: 25rem;
}
.ebcInteractiveListSecondTab div{
    padding: 8rem 16rem;
    border-radius: var(--ebc-corner-radius-full);
    background: var(--ebc-neutral-bg_b);
    color: var(--ebc-text-secondary);
    box-sizing: border-box;
    cursor: pointer;
}

.ebcInteractiveListSecondTab div.active{
    border: 1px solid var(--ebc-brand-secondary-red);
    background-color: #fff;
    color: var(--ebc-brand-secondary-red);
}
.ebcInteractiveListSecondTab::-webkit-scrollbar{
    display: none;
}
@media (max-width:996px){
.ebcInteractiveListSecondTab{
gap: 24rem;
}
.ebcInteractiveListSecondTab div{
    padding-inline:24rem;
    line-height: 40rem;
    white-space: nowrap
}
}
@media (min-width: 996px) {}

.ebcInteractiveTopicNewDesc {
    color: var(--ebc-text-secondary);
    margin: 8rem 0;
}

.ebcInteractiveTopicNewTime {
    color: var(--ebc-text-secondary);
}

.ebcInteractive-prev img,
.ebcInteractive-next img {
    width: 32rem;
    height: 32rem;
}

.ebcInteractive-next img {
    transform: rotate(180deg);
}

.ebcInteractive-prev,
.ebcInteractive-next {
    position: absolute;
    top: 344rem;
    z-index: 2;
}

.ebcInteractive-prev {
    left: 492rem;
}

.ebcInteractive-next {
    right: 16rem;
}



.ebcInteractiveHotListTitle {
    padding: 11rem 0 8rem;
    color: var(--ebc-brand-secondary-red);
    background: url('../assets/image/ebcInteractive/ebcInteractiveHeaderListBg.png') no-repeat;
    background-size: 100% 100%;
}

.ebcInteractiveHotList {
    flex: 1;
}

.ebcInteractiveHotListItem {
    gap: 16rem;
    padding: 16rem 0;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.12);
}

.ebcInteractiveHotListItem .itemWord {
    color: var(--ebc-text-primary);
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ebcInteractiveTopicNewTitle {
    color: var(--ebc-text-primary);
}

.ebcInteractiveHotListItem:hover .itemWord {
    color: var(--ebc-brand-secondary-red);
}

.ebcInteractiveHotListItem .itemTime-yearMonth {
    color: var(--ebc-text-secondary);
    width: 52rem;
}

.ebcInteractiveHotListItem:nth-of-type(1) {
    padding: 24rem 0 16rem;
}

@media (max-width:996px) {
    body {
        background: url('../assets/image/ebcInteractive/ebcInteractiveHeaderM.png') no-repeat;
        background-size: 100% 1360rem;
    }

    .ebcInteractiveTopicNew {
        width: 100%;
    }

    .ebcInteractiveTopic .contentBox {
        flex-direction: column;
        gap: 96rem;
        padding-inline: 32rem;
    }

    .ebcInteractiveSlide {
        width: 100%;
    }

    .ebcInteractiveTopic .swiper-slide img {
        width: 686rem;
        height: 456rem;
    }

    .ebcInteractiveTopic {
        padding: 32rem 0 96rem;
    }

    .ebcInteractiveHotListTitle {
        padding: 16rem 0 24rem;
        font-size: 40rem;
        line-height: 56rem;
        background: url('../assets/image/ebcInteractive/ebcInteractiveHeaderListBgM.png') no-repeat;
        background-size: 100% 100%;
    }

    .ebcInteractiveHotListItem {
        gap: 32rem;
        padding: 32rem 0;
    }

    .ebcInteractiveHotListItem:nth-of-type(1) {
        padding-top: 48rem;
    }


}


.ebcInteractiveList {
    padding-bottom: 120rem;
}

.ebcInteractiveListTab {
    padding-left: calc(50vw - 600rem);
    margin-bottom: 25rem;
    gap: 32rem;
}

.ebcInteractiveListTab>div {
    padding-inline: 8rem;
    white-space: nowrap;
}

.ebcInteractiveListTab {
    position: sticky;
    top: 80px;
    z-index: 2;
    padding-block: 15rem;
}

.ebcInteractiveListTab.is-pinned {
    background: #fff;
}

.ebcInteractiveListTab .active {
    color: var(--ebc-brand-secondary-red);
    font-weight: 500;
    padding-bottom: 4rem;
    border-bottom: 2px solid var(--ebc-brand-secondary-red)
}

.ebcInteractiveListPart {
    gap: 24rem;
    flex-wrap: wrap;
}

.ebcInteractiveListItem {
    flex: 0 0 280rem;
    position: relative;
}

.ebcInteractiveListItem img {
    width: 100%;
    height: 188rem;
    border-radius: 6rem;
}

.ebcInteractiveListItemTitle {
    margin-top: 8rem;
    margin-bottom: 8rem;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
}

.ebcInteractiveListItemTime {
    font-size: 14rem;
    line-height: 18rem;
    color: var(--ebc-text-secondary_white);
    display: flex;
    color: var(--ebc-text-secondary);
    margin-bottom: 5rem;
    margin-top: 1rem;
}

.ebcInteractiveListPagation>* {
    width: 40rem;
    height: 40rem;
    text-align: center;
    line-height: 40rem !important;
    color: var(--ebc-text-secondary);
}

.ebcInteractiveListPagation .pagePrev {
    margin-right: 8rem;
}

.ebcInteractiveListPagation .pageNext {
    margin-left: 8rem;
}

.ebcInteractiveListPagation .activePage {
    border-radius: var(--ebc-corner-radius-full);
    background: rgba(165, 41, 51, 0.10);
    color: var(--ebc-brand-secondary-red);
    font-weight: 500;
}

.ebcInteractiveListPagation .pageNext {
    transform: rotate(180deg);
}

.ebcInteractiveListTab a {
    color: var(--ebc-text-secondary);
}

.ebcInteractiveListTab a:hover,
.ebcInteractiveTopicNewTitle:hover,
.ebcInteractiveListItem:hover .ebcInteractiveListItemTitle {
    color: var(--ebc-brand-secondary-red);
}

@media (max-width:996px) {

    .ebcInteractiveList {
        padding-inline: 32rem;
    }

    .ebcInteractiveListTab {
        margin-bottom: 32rem;
        top: 44px;
        width: 100vw;
        margin-left: -32rem;
        padding-inline: 32rem;
        overflow: auto;
    }

    .ebcInteractiveListTab::-webkit-scrollbar {
        display: none;
    }

    .ebcInteractiveListTab a {
        white-space: nowrap;
    }

    .ebcInteractiveListItem {
        padding: 32rem 0;
        flex: 1;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }

    .ebcInteractiveListItem img {
        float: right;
        width: 240rem;
        height: 160rem;
        border-radius: 16rem;
    }

    .ebcInteractiveListItemTitle {
        width: 414rem;
        height: 88rem;
        margin-bottom: 8rem;
        margin-top: 12rem;
    }

    .ebcInteractiveListItemTime {
        left: 0;
        bottom: 42rem;
        top: unset;
        position: absolute;
        font-size: var(--ebc-fontsize-25);
    }

    .ebcInteractiveListPagation {
        margin-top: 48rem;
    }

    .ebcInteractiveListPagation>* {
        width: 80rem;
        height: 80rem;
        line-height: 80rem !important;
    }

    .ebcInteractiveHotListItem .itemTime-yearMonth {
        color: var(--ebc-text-secondary);
        width: 104rem;
    }
}
</style>